export const FILE_UPLOAD_LIMIT = "15Mb";
export const COMMODITY_CODES_URL = "https://www.trade-tariff.service.gov.uk/sections";

export const ITEM_QUERY_PARAM = "item";
export const PAGE_QUERY_PARAM = "page";
export const TAB_QUERY_PARAM = "tab";
export const ELEMENT_QUERY_PARAM = "element";
export const CREATION_TIME_QUERY_PARAM = 'creation-time';
export const AMENDMENT_QUERY_PARAM = 'amendment';

export const LS_THEME_KEY = "theme";
export const LS_LANGUAGE_KEY = "language";
export const LS_ACCESS_TOKEN_KEY = "access_token";
export const LS_REFRESH_TOKEN_KEY = "refresh_token";
export const LS_ID_TOKEN_KEY = "ID_TOKEN";

export const FILE_SIZE_LIMIT = 100;

export const DECLARATION_STATUSES_MAP = {
	SUCCESS: "accepted",
	FAILURE: "rejected",
	PENDING: "pending",
	NEW: "notSubmitted",
};